import React from 'react';
import * as S from './style';
import composeStyle from '../../utils/composeStyle';

import * as T from '../Typography';

const Component = composeStyle(T.H2, 'H3', 'H4Bold');
// renders headlines with line underneath
const HeadlineTitle = ({ children, color = 'midnight', lineColor, lightLine, ...rest }) => {
  return (
    <S.Wrapper>
      <Component color={color} {...rest}>
        {children}
      </Component>
      <S.Line color={lineColor} lightLine={lightLine} />
    </S.Wrapper>
  );
};

export default HeadlineTitle;
